import { createRouter as createRouterLib, createWebHistory, createWebHashHistory } from "vue-router";
import { setupLayouts } from "virtual:generated-layouts";
import { routes } from "vue-router/auto-routes";
import { useAuthStore } from "./stores/authStore";

/**
 *
 * @returns {import("vue-router").Router}
 */
export function createRouter() {
  const router = createRouterLib({
    history:
      window.cordova?.platformId ?
        createWebHashHistory(import.meta.env.VITE_BASE_URL || "/")
      : createWebHistory(import.meta.env.VITE_BASE_URL || "/"),
    routes: setupLayouts(routes),
    scrollBehavior: (to, from, savedPosition) => {
      if (to.hash) {
        return { selector: to.hash, behavior: "smooth" };
      } else if (savedPosition) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }
    },
  });

  const isPublicPath = (to) => {
    for (let i = to.matched.length - 1; i >= 0; i--) {
      if (to.matched[i].meta.public !== undefined) {
        return to.matched[i].meta.public;
      }
    }
    return false;
  };

  router.beforeEach(async (to) => {
    if (to.query && to.query.auth) {
      // Login as the user in shadow mode
      const loadingStore = useLoadingStore();
      const authStore = useAuthStore();
      loadingStore.setLoading(true);
      authStore.logout().then(async function () {
        await authStore.authenticate({ access_token: to.query.auth, shadow: true });
        let query = Object.assign({}, to.query);
        delete query.auth;
        setTimeout(function () {
          // @ts-ignore
          location.search = new URLSearchParams(query).toString();
        }, 500);
      });
      return;
    }

    const authStore = useAuthStore();
    const me = await authStore.authenticate();
    if (isPublicPath(to)) {
      return;
    } else if (me) {
      return;
    } else {
      return { path: "/signin", query: { redirect: to.fullPath } };
    }
  });

  window["handleOpenURL"] = (url) => {
    router.push(url.replace(/^[a-zA-Z]+:\/\/((www\.)?(go|event)(\.[a-z]+)?\.alvarum\.com\/)?\/?/, "/")).catch(() => {});
  };

  // @ts-ignore
  return router;
}
